const options = {
  5: "bg-orange-300/5",
  10: "bg-orange-300/10",
  25: "bg-orange-300/25",
  50: "bg-orange-300/50",
  75: "bg-orange-300/75",
  90: "bg-orange-300/90",
  100: "bg-orange-300",
};

const from = {
  5: "from-orange-300/5",
  10: "from-orange-300/10",
  25: "from-orange-300/25",
  50: "from-orange-300/50",
  75: "from-orange-300/75",
  90: "from-orange-300/90",
  100: "from-orange-300",
};

export default function getBackgroundOrange300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
